import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';

@Component({
  selector: 'sia-google-search-button',
  templateUrl: './sia-google-search-button.component.html',
  styleUrls: ['./sia-google-search-button.component.scss'],
  standalone: true,
  imports: [MatIconButton],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiaGoogleSearchButtonComponent {
  sessionCrudKey?: string;
  readonly urlPattern = input<string | undefined>();
  readonly guid = input<string | undefined | null>();
  readonly data = input<any>();

  constructor() {
    effect(() => {
      const guid = this.guid();
      this.sessionCrudKey = guid ? `${guid}-crud-item` : undefined;
    });
  }

  openUrl() {
    this.openWindow();
  }

  private openWindow() {
    const urlPattern = this.urlPattern();
    if (urlPattern) {
      const data = this.data();
      let googleQuery = '';
      urlPattern.split('|').forEach((part: string) => {
        var propertyName = part.replace('[', '').replace(']', '');
        var propertyValue = data[propertyName];
        if (propertyValue) {
          if (googleQuery) {
            googleQuery += '+';
          }
          googleQuery += encodeURIComponent(propertyValue);
        }
      });
      if (googleQuery) {
        window.open('https://www.google.com/search?q=' + googleQuery, '_blank');
      }
    }
  }
}
